import iptvisionsLogo from "@/assets/iptvisions-logo.svg";

export function PremiumBrandMark({ size = "md", testId = "premium-brand-mark", label = "IPTVISIONS" }) {
  return (
    <img className={`premium-logo-mark premium-logo-${size}`} src={iptvisionsLogo} alt={label} data-testid={testId} aria-label={label} loading="eager" decoding="async" />
  );
}